<template>
    <div>
        <span v-if="loading"><i class="far fa-circle-notch fa-spin"></i> Récupération des données en cours</span>

        <span class="ix-text-small ix-text-secondary" v-if="!loading && count == 0">Nous ne trouvons pas de données à vous afficher</span>

        <div class="row" v-if="!loading && count != 0">
            <div class="col-sm-12 col-md-6 col-lg-2">
                <custom-chart type="pie" :datasets="chart.datasets" :labels="chart.labels" :options="chart.options"></custom-chart>
            </div>

            <div class="col-sm-12 col-md-6 col-lg-10">
                <div class="ix-table-box">
                    <table class="ix-table">
                        <tbody>
                            <tr v-for="(type, index) in types" v-bind:key="index">
                                <td>{{ type.label }}</td>
                                <td class="text-center">{{ type.count }}</td>
                                <td class="text-center">{{ type.percent }}%</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="row mt-3" v-if="last_at != null || turnover != null || seniority != null">
                    <div class="col-sm-12 col-md-12 col-lg-4" v-if="last_at != null">
                        <div class="ix-count-box">
                            <h2 class="ix-count-box-title">Date dernier recrutement</h2>
                            <span class="ix-count-box-value">{{ last_at }}</span>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-12 col-lg-4" v-if="turnover != null">
                        <div class="ix-count-box">
                            <h2 class="ix-count-box-title">Turnover ({{ moment().format('YYYY') }})</h2>
                            <span class="ix-count-box-value">{{ turnover }}%</span>
                        </div>
                    </div>

                    <div class="col-sm-12 col-md-12 col-lg-4" v-if="seniority != null">
                        <div class="ix-count-box">
                            <h2 class="ix-count-box-title">Ancienneté moyenne</h2>
                            <span class="ix-count-box-value">
                                {{ seniority.years }} an{{ seniority.years > 1 ? 's' : '' }}
                                <span v-if="seniority.months > 0">et {{ seniority.months }} mois</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CustomChart from '../CustomChart.vue';

    export default {
        props : {
            route : String,
        },
        components: {
            CustomChart
        },
        data() {
            return {
                loading: true,

                types : [],
                count : 0,
                last_at : null,
                turnover : null,
                seniority: null,

                chart: {
                    options: {
                        plugins: {
                            legend: {
                                display: false,
                            }
                        }
                    },
                    labels: [],
                    datasets: [
                        {
                            label: "Statistiques",
                            backgroundColor: [],
                            data: [],
                        }
                    ]
                }
            };
        },
        methods : {
            getData : async function(){
                fetch(this.route, {
                    ...{
                        method: 'GET'
                    },
                    ...this.getHttpJsonRequestHeaders()
                }).then((response) => {
                    return response.json();
                }).then((data) => {
                    this.count = data.count
                    this.types = data.types
                    this.last_at = data.last_at
                    this.turnover = data.turnover
                    this.seniority = data.seniority

                    this.chart.labels = this.types.map(type => { return type.short })
                    this.chart.datasets[0].backgroundColor = this.types.map(type => { return type.color })
                    this.chart.datasets[0].data = this.types.map(type => { return type.count })
                    
                    this.loading = false
                }).catch(error => {
                    console.log(error)
                });
            },
        },
        async mounted() {
            await this.getData();
        }
    }
</script>
